import { render, staticRenderFns } from "./back-to-top.vue?vue&type=template&id=1fda87ac&scoped=true&"
import script from "./back-to-top.vue?vue&type=script&lang=js&"
export * from "./back-to-top.vue?vue&type=script&lang=js&"
import style0 from "./back-to-top.vue?vue&type=style&index=0&id=1fda87ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fda87ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/apple/Desktop/linebot-backend.hciot.com.tw/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fda87ac')) {
      api.createRecord('1fda87ac', component.options)
    } else {
      api.reload('1fda87ac', component.options)
    }
    module.hot.accept("./back-to-top.vue?vue&type=template&id=1fda87ac&scoped=true&", function () {
      api.rerender('1fda87ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components-demo/back-to-top.vue"
export default component.exports